var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0156 7.23438C16.0469 7.67187 17.7188 8.71875 19.0312 10.375C20.3438 12 21 13.875 21 16C21 18.125 20.3438 20.0156 19.0312 21.6719C17.7188 23.2969 16.0469 24.3281 14.0156 24.7656V22.7031C15.4844 22.2656 16.6719 21.4375 17.5781 20.2188C18.5156 19 18.9844 17.5938 18.9844 16C18.9844 14.4062 18.5156 13 17.5781 11.7812C16.6719 10.5625 15.4844 9.73438 14.0156 9.29688V7.23438ZM16.5 16C16.5 17.875 15.6719 19.2188 14.0156 20.0312V11.9688C14.7031 12.3125 15.2812 12.875 15.75 13.6562C16.25 14.4375 16.5 15.2188 16.5 16ZM3 13H6.98438L12 7.98438V24.0156L6.98438 19H3V13Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeUp);
export default __webpack_public_path__ + "static/media/volume_up.4dc97377d9e29fd9e7c99dedf99ac07e.svg";
export { ForwardRef as ReactComponent };